(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tolstoy-video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const tolstoyContainers = document.querySelectorAll('.tolstoy-video-container');

    if ('IntersectionObserver' in window) {
      const observerOptions = {
        root: null,
        rootMargin: '200px',
        threshold: 0,
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const container = entry.target;
            const template = container.querySelector('template');

            if (template) {
              const content = template.content.cloneNode(true);
              container.appendChild(content);
              template.remove();
            }

            observer.unobserve(container);
          }
        });
      }, observerOptions);

      tolstoyContainers.forEach((container) => {
        observer.observe(container);
      });
    } else {
      // Fallback for browsers without IntersectionObserver
      tolstoyContainers.forEach((container) => {
        const template = container.querySelector('template');
        if (template) {
          const content = template.content.cloneNode(true);
          container.appendChild(content);
          template.remove();
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
